import UtilsUrl from "../../utils/UtilsUrl";
import api from "./../api";

class ClientService {
  getAllClients(id) {
    return api.get(UtilsUrl.ClientPosURL() + "/getAllClients/" + id);
  }
  getClientsByFilter(model) {
    return api.post(UtilsUrl.ClientPosURL() + "/getCustomer", model);
  }
  getClientDetails(id) {
    return api.get(UtilsUrl.ClientPosURL() + "/getClientDetails/" + id);
  }
}
export default new ClientService();
